import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, Modal, Result, notification } from 'antd';
import { MailOutlined } from '@ant-design/icons';

import { forgot } from '../../actions/auth/forgot';
import { MAIL_SENDER } from '../../lib/mail_sender';

const FormItem = Form.Item;

export const ModalRecoveryPassword = ({ visible, setVisible }) => {

    // Funcion que permite ejecutar todas las acciones del estado de redux
    const dispatch = useDispatch();

    // Manejo de los estados del componente
    const [loading, setLoading] = useState(false);
    // Correo al que se envió el enlace; null = todavía muestra el formulario
    const [sentTo, setSentTo] = useState(null);
    // Hook para el control de los formularios
    const [form] = Form.useForm();

    // Invalida las promesas en vuelo cuando el modal se cierra: una respuesta
    // tardía no debe re-abrir el estado de éxito ni notificar un error de una
    // solicitud que el usuario ya abandonó.
    const requestRef = useRef(0);

    const onClose = () => {
        requestRef.current += 1;
        setVisible(false);
        setSentTo(null);
        setLoading(false);
        form.resetFields();
    };

    // Solicita el enlace de restablecimiento. La respuesta es genérica
    // (anti-enumeración): el estado de éxito se muestra exista o no la
    // cuenta; solo errores reales (cooldown, config, red) notifican.
    const onRecovery = ({ email }) => {
        const reqId = ++requestRef.current;
        setLoading(true);
        dispatch( forgot( email ) )
            .then( () => {
                if ( reqId !== requestRef.current ) return;
                setSentTo(email);
            } )
            .catch( error => {
                if ( reqId !== requestRef.current ) return;
                notification.warning({
                    message: 'No se pudo enviar el correo',
                    description: error?.code === 'functions/resource-exhausted'
                        ? 'Espere un momento antes de solicitar otro correo.'
                        : 'Ocurrió un error al enviar el correo. Intente de nuevo.',
                    placement: 'topRight'
                });
            } )
            .finally( () => { if (reqId === requestRef.current) setLoading(false); } );
    };

    return (
        <Modal
            forceRender
            title = { sentTo ? null : 'Restablecer contraseña' }
            cancelText = 'Cancelar'
            okText = { sentTo ? 'Entendido' : 'Enviar enlace' }
            cancelButtonProps = { sentTo ? { style: { display: 'none' } } : undefined }
            maskClosable = { false }
            destroyOnHidden = { true }
            closable = { false }
            open = { visible }
            confirmLoading = { loading }
            onCancel = { onClose }
            onOk = { () => sentTo ? onClose() : form.submit() } >
            { sentTo
                ? <Result
                    status = 'success'
                    title = 'Revisa tu correo'
                    subTitle = { <>
                        Te enviamos un correo desde <strong>{ MAIL_SENDER }</strong> a <strong>{ sentTo }</strong> con
                        un enlace para restablecer tu contraseña. Si no lo ves, revisa la carpeta de spam.
                    </> } />
                : <Form form = { form } layout = 'vertical' onFinish = { onRecovery } >
                    <p> Ingresa el correo con el que inicias sesión y te enviaremos un enlace para restablecer tu contraseña </p>
                    <FormItem name = "email" label = "Correo electrónico"
                        rules = {[
                            { required: true, message: 'Debe ingresar una direccion de correo' },
                            { type: 'email', message: 'Debe ingresar una direccion de correo valida' }
                        ]} >
                        <Input type = "email" placeholder = "usuario@empresa.com" prefix = { <MailOutlined style = {{ color: 'rgba(0,0,0,.25)' }} /> } />
                    </FormItem>
                </Form>
            }
        </Modal>
    )
}
